<template>
  <div class="choose-screen setMobileHeroNavigation">
    <template>
      <h1>Qual o melhor tamanho de tela para o seu ambiente?</h1>
      <div class="range-slider-marks largeContainer">
        <RangeSliderMarks @selectInch="onSelectInch" :userChoices="this.userChoices" />
      </div>
      <div class="distance-area largeContainer">
        <div :class="[inchClass]" class="div_sofa">
          <img src="../../assets/sofa.png" alt="Ilustração do sofá à esquerda" />
          <div class="distance-info">
            <span class="distance-info-title">
              <div></div>
              <small>Distância</small>
            </span>
            <span v-if="minInch === maxInch" class="distance-info-number" >
              mínima
                <span v-if="minInch" class="distance-info-inch">{{ minInch }}”</span>: {{ minDistance }}
            </span>

            <span v-else class="distance-info-number">
              mínima
                <span v-if="minInch" class="distance-info-inch">{{ minInch }}”</span>: {{ minDistance }}
              /
              mínima
                <span v-if="maxInch" class="distance-info-inch">{{ maxInch }}”</span>: {{ maxDistance }}
            </span>
          </div>
          <img src="../../assets/tv.png" alt="Ilustração da TV à direita" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import RangeSliderMarks from "../RangeSliderMarks.vue";
import { getMinDistance } from '../../constants/distance';

export default {
  name: "ChooseInchesScreen",
  components: { RangeSliderMarks },
  props: ["sendAnalytics", "userChoices"],
  data() {
    return {
      minInch: '',
      maxInch: '',
      minDistance: getMinDistance('43'),
      maxDistance: getMinDistance('85'),
      inchClass: ''
    };
  },
  methods: {
    onSelectInch(selectInch) {
      
      this.minInch = selectInch[0];
      this.maxInch = selectInch[1];
      this.minDistance = getMinDistance(selectInch[0]);
      this.maxDistance = getMinDistance(selectInch[1]);
      this.inchClass = 'inch' + selectInch[1];
      this.$emit('clickSelectInch', selectInch);
    }
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.choose-screen {
  display: flex;

  width: 100%;
  // min-height: 730px;
  min-height: 730px;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  background-color: $color-gray;

  h1 {
    font-family: $font-family-title;
    font-size: 2.5rem;
    line-height: 3rem;

    text-align: center;

    max-width: 1000px;

    padding: 2% 0 0 20%;
  }

  .range-slider-marks,
  .distance-area {
    display: flex;
    justify-content: center;
    align-items: center;

    max-width: 1000px;

    flex-wrap: wrap;

    padding: 65px 0 0 20%;
    gap: 1.5rem;
  }

  .distance-area {
    margin-top: 40px;
    position: relative;

    div {
      width: 700px;
      display: flex;
      justify-content: space-between;
      transition: width 0.3s ease-in-out;

      .distance-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;
        justify-content: center;
        margin-left: 25px;

        span {
          text-align: center;
          width: 100%;
        }

        span:last-child {
          padding-top: 5px;
          
        }
       
      }
    }
  }
  .distance-info{
   
    .distance-info-title {
      padding-bottom: 5px;
      font-family: $font-family-title;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      small{
        font-size: 16px;
        background: #2b2b2b;
        color: #fff;
        padding: 5px 10px;
        border-radius: 25px;
        position: relative;
        z-index: 1;
        display: block;
      }
      &:before{
        content: " ";
        display: block;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAAQCAYAAACV8KRlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEJSURBVHgB7drNDYJAEIbhGULkagmUoB1oB5YBhsQpZY92YQnagXYgJXjFxF1Z9WCUEeLiz+F7brqztzcsEIgUIjKUopgRQA+kyGciWaqtR42bsix1x2pr7WkleY4YIUhRR2gtreyR11qMTyFeIox47Yj8hpIStyOAAHGcbNi3VDelxcj3Px4jjAZuasyyJIBAbW1x10GAUK8a47YBgD5prTEihG9rao4X83x/+wPgV8qIAP5AzNZNCUczfFHj0awtIEb4BPVhpW2AAHrS+vqmyyBAiM4vtPUNydgYcyCAN3W5wD09NZtlfV7by82jH0ypqiYEECLm0dunrK/Yf7pDAD24fgYmQ239DK4C2YgQfHnCAAAAAElFTkSuQmCC);
        height: 20px;
        background-size: cover;
        position: absolute;
        width: 100%;
        transform: translateY(-50%);
        top: 50%;
        background-repeat: no-repeat;
        left: 0;
        max-width: 19px;
        height: 16px;
      }
      &:after{
        content: " ";
        display: block;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAAQCAYAAACV8KRlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEJSURBVHgB7drNDYJAEIbhGULkagmUoB1oB5YBhsQpZY92YQnagXYgJXjFxF1Z9WCUEeLiz+F7brqztzcsEIgUIjKUopgRQA+kyGciWaqtR42bsix1x2pr7WkleY4YIUhRR2gtreyR11qMTyFeIox47Yj8hpIStyOAAHGcbNi3VDelxcj3Px4jjAZuasyyJIBAbW1x10GAUK8a47YBgD5prTEihG9rao4X83x/+wPgV8qIAP5AzNZNCUczfFHj0awtIEb4BPVhpW2AAHrS+vqmyyBAiM4vtPUNydgYcyCAN3W5wD09NZtlfV7by82jH0ypqiYEECLm0dunrK/Yf7pDAD24fgYmQ239DK4C2YgQfHnCAAAAAElFTkSuQmCC);
        height: 20px;
        background-size: cover;
        position: absolute;
        width: 100%;
        transform: translateY(-50%) rotate(180deg);
        top: 50%;
        background-repeat: no-repeat;
        right: 0;
        max-width: 19px;
        height: 16px;
      }
      div{
        display: block;
        position: absolute;
        width: 93%;
        height: 2px;
        background: #6e6a69;
        transform: translateY(-50%);
        top: 50%;
      }
    }
  }

  .distance-info-inch {
    font-family: $font-family-title;
  }

  .largeContainer {
    max-width: 100%;
    // margin: 65px -275px 0 0;
  }

  .distance-area {
    max-width: 100%;
  }
}

@media (max-width: 1166px) {
  .choose-screen {
    .range-slider-marks {
      max-width: 600px;
    }
  }
}

@media (max-width: 900px) {
  .choose-screen {
    padding-bottom: 10%;
    .range-slider-marks {
      max-width: 500px;
    }
  }
}

@media (max-width: $bp-mobile) {
  .choose-screen {
    padding: 17% 0 10% 0;
    min-height: 530px;

    h1 {
      padding: 0;
      max-width: 500px;
      margin: 0 $margin-side-title-mobile;
      font-size: 2rem;
      line-height: 2.3rem;
    }

    .range-slider-marks,
    .distance-area {
      max-width: 100%;
      padding: 25px 0 0 0;
    }
  }


}

@media (max-width: 572px) {
  .choose-screen {
    padding: 23% 0 10% 0;

    h1 {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
}

// Ilustrações
@media (min-width: 768px) and (max-width: 990px) {
  .distance-area > div{
    
      width: 500px !important;
    
  }
}

@media (max-width: $bp-mobile) {
  .choose-screen{
    .distance-info-title{
      font-size: 14px;
    }
    .distance-area {
      margin: 0 auto;
      box-sizing: border-box;
      min-height: 222px;
      align-items: flex-start;
      div {
        max-width: 100%;
        border-radius: 0;
        justify-content: center;

        .distance-info {
          margin-left: 0;
        }

        img:first-child {
          max-width: 170px;
          content: url("../../assets/sofa_mobile.png");
        }

        img:last-child {
          max-width: 75px;
          content: url("../../assets/tv_mobile.png");
        }

      }
    }
  }
  span.distance-info-number{
    position:absolute;
    bottom: 0;
    max-width: fit-content;
  }
}
 
 

@media (max-width: 325px) {
  .distance-area {
    div {
      max-width: calc(100vw - 35px);
      border-radius: 0;
    }
  }
}

@media (min-width: 1024px) {
  .distance-area {
    .inch30 {
      width: 420px !important;
    }
    .inch43 {
      width: 440px !important;
    }
    .inch50 {
      width: 477px !important;
    }
    .inch55 {
      width: 514px !important;
    }
    .inch60 {
      width: 551px !important;
    }
    .inch65 {
      width: 588px !important;
    }
    .inch70 {
      width: 625px !important;
    }
    .inch75 {
      width: 662px !important;
    }
    .inch85 {
      width: 700px !important;
    }
  }
}

@media (max-width: 1024px) {
  .distance-area {
    .inch30 {
      width: 83% !important;
    }
    .inch43 {
      width: 84% !important;
    }
    .inch50 {
      width: 85% !important;
    }
    .inch55 {
      width: 86% !important;
    }
    .inch60 {
      width: 90% !important;
    }
    .inch65 {
      width: 93% !important;
    }
    .inch70 {
      width: 94% !important;
    }
    .inch75 {
      width: 95% !important;
    }
    .inch85 {
      width: 100% !important;
    }
  }
}
</style>
